module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SCROSS-4.5fbce523.jpg";